module.exports = __webpack_public_path__ + "static/media/everest.d2af7cbd.jpg";